/* Informational coverage only. Shopify checkout enforces delivery eligibility. */
(function (root) {
  function normalizeZip(value) {
    const input = String(value ?? '').trim();
    return /^\d{5}(?:-\d{4})?$/.test(input) ? input.slice(0, 5) : null;
  }
  function checkZip(value, codes) {
    const zip = normalizeZip(value);
    return zip === null ? 'invalid' : codes.includes(zip) ? 'covered' : 'outside';
  }
  root.AmourDelivery = { normalizeZip, checkZip };
  if (typeof document === 'undefined') return;
  function bind(container) {
    container.querySelectorAll('[data-af-delivery]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      const codes = JSON.parse(form.querySelector('[data-af-zips]').textContent);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        const input = form.querySelector('input');
        const result = form.querySelector('[data-af-result]');
        const status = checkZip(input.value, codes);
        input.setAttribute('aria-invalid', status === 'invalid' ? 'true' : 'false');
        const messages = {
          invalid: 'Please enter a five-digit ZIP code, such as 75034, or a ZIP+4 code.',
          covered: 'Your ZIP code is in our delivery area. Available dates and final eligibility are confirmed at checkout.',
          outside: 'This ZIP code is outside our current delivery area.'
        };
        result.textContent = messages[status];
        result.dataset.status = status;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(document));
  else bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})(globalThis);
